import axios from 'axios'

import { resolveRequest } from 'utility-tools/module/requests'
import constants from 'nexchange-service/constants'

import { IKycDetailsApiDto } from './api.types'

const { API_URL } = constants

const USE_TEST_API = false // DANGER because effects both obron and yoa websites

const requestOrderKycDetails = async (orderId: string) =>
    resolveRequest<IKycDetailsApiDto>(
        USE_TEST_API
            ? axios.get(`https://sapi.n.exchange/en/api/v1/kyc/${orderId}/`) // Testing worldpay
            : axios.get(`${API_URL}/kyc/${orderId}/`),
    )

export { requestOrderKycDetails }
